export default __webpack_public_path__ + "static/media/background_night.73629c89.jpg";